var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[(this.receipt.error)?_c('i',{staticClass:"mdi error-icon mdi-circle",attrs:{"title":this.receipt.error}}):_vm._e(),_c('i',{staticClass:"mdi cfdi-icon",class:`mdi-${_vm.iconClass}`,attrs:{"title":this.receipt.cfdiStatus || 'Desconocido'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }